import { Injectable } from '@angular/core';
import { Actions, createEffect } from '@ngrx/effects';



@Injectable()
export class NavigationEffects {



  constructor(private actions$: Actions) {}

}
